<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="title">Create Account</h1>
  </div>
</div>
<div class="row">
  <div class="col-md-6 offset-md-3 text-center subtitle">
    Please enter your user name, password and email.
  </div>
</div>
<div class="row">
  <div class="col-md-4 offset-md-4">
    <div class="card">
      <div class="card-body">
        <h2>Create Account</h2>
        <div class="col-md-10">
          <form name="userCreateForm" (ngSubmit)="save()" novalidate #f="ngForm">
            <div class="form-group">
              <label for="inputFirstName">*First Name:</label>
              <input type="text" class="form-control" id="inputFirstName" [(ngModel)]="userEdit.firstName" aria-describedby="inputFirstName" placeholder="First Name" name="first">
            </div>
            <div class="form-group">
              <label for="inputLastName">*Last Name:</label>
              <input type="text" class="form-control" id="inputLastName" [(ngModel)]="userEdit.lastName" aria-describedby="inputLastName" placeholder="Last Name" name="last">
            </div>
            <div class="form-group">
              <label for="inputEmail">*Email</label>
              <input type="email" class="form-control" id="inputEmail" [(ngModel)]="userEdit.email" aria-describedby="inputEmail" placeholder="Email" name="email">
            </div>
            <div class="form-group">
              <label for="inputPassword">*Password:</label>
              <input type="password" class="form-control" id="inputPassword" [(ngModel)]="userEdit.newPassword" placeholder="Password" name="password">
            </div>
            <div class="form-group">
              <label for="inputPasswordConfirm">*Confirm Password:</label>
              <input type="password" class="form-control" id="inputPasswordConfirm" [(ngModel)]="userEdit.confirmPassword" placeholder="Confirm Password." name="confirmPassword">
            </div>
            <br />
            <button type="submit" class="btn btn-primary">Create User</button>
          </form>
        </div>
        <div class="row">
          <div class="col-md-6 offset-md-6 text-right">
            <button type="button" [routerLink]='["/account/login"]' class="btn btn-link">Login</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

